import Landing from '../routes/landings/AiDesign'

const AiInteriorDesignApp = () => {
  return <Landing />
}

export default AiInteriorDesignApp
